import React, { useState } from 'react';
import useScrollPosition from '../../hooks/useScrollPosition';
import styled from 'styled-components/macro';
import { CSSTransition } from 'react-transition-group';
import './styles.css';
import { FiChevronUp } from 'react-icons/fi';
import { useTranslate } from '../../contexts/languageContext';
import { useIsDesktop } from '../../hooks/useMediaQuery';
/**
 * Muestra un botón que nos permite ir al principio de la página cuando hemos hecho suficiente
 * scroll hacia abajo.
 */

const ScrollToTop = () => {
  const [show, setShow] = useState(false);
  const t = useTranslate();
  const isDesktop = useIsDesktop();

  useScrollPosition(
    ({ prevPos, currPos }) => {
      const shouldShow = currPos.y < -800;
      if (shouldShow !== show) setShow(shouldShow);
    },
    [show]
  );
  return (
    <div>
      <CSSTransition
        classNames="scroll-to-top"
        in={show}
        timeout={200}
        unmountOnExit
      >
        <SButton
          href="#top"
          aria-label={t('irAlInicioDeLaPagina')}
          isDesktop={isDesktop}
        >
          <FiChevronUp
            css="width: 28px;
               height: 28px;
               vertical-align: middle;"
            color="white"
          />
        </SButton>
      </CSSTransition>
    </div>
  );
};

const SButton = styled.a`
  position: fixed;
  bottom: ${({ isDesktop }) => (isDesktop ? '0' : '4rem')};
  right: 0;
  background:#1C4183;
  margin: 30px;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2),
    0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);

  @media (max-width: 768px) {
    margin-bottom: 65px;
    margin-right: 15px;
    bottom: 0;
  }
`;

export default ScrollToTop;
